import linkedin from "./images/linkedin.png"
import github from "./images/github.png"
import mail from "./images/gmail.png"
import { Button } from "@mui/material"
import "../styles/Footer.css"

const Footer = () => {
    return (
        <div className="footer-container">
            <div className="footer-buttons">
            <Button href="mailto: fatihdurmaz@sabanciuniv.edu">
                <img src={mail} height={30} width={38}></img>
            </Button>
            <Button href="https://www.linkedin.com/in/fatihdurmaz99/">
                <img src={linkedin} height={30} width={38}></img>
            </Button>
            <Button href="https://github.com/fthdrmzzz">
                <img src={github} height={30} width={30}></img>
            </Button>
            </div>
            <a className="text">Designed by Fatih Durmaz, Inspired by Hasan Ocak</a>
        </div>)
}

export default Footer